import { useCallback } from 'react';
import { useNews } from '../components/NewsContext';

const useNewsSectionPrefetch = (section, limitCount = 25) => {
  const { loadSectionNews } = useNews();

  return useCallback(() => {
    if (!section) {
      return;
    }

    loadSectionNews(section, limitCount).catch((error) => {
      if (process.env.NODE_ENV === 'development') {
        console.debug('News section prefetch failed:', error);
      }
    });
  }, [limitCount, loadSectionNews, section]);
};

export default useNewsSectionPrefetch;
